import { getActiveShoppingListItems } from 'redux/modules/shopping-list/selectors';

import productGridImpressions from 'redux/middleware/analytics/actions-to-track/products-and-components/product-grid-impressions';

export default productGridImpressions({
  fetch: getActiveShoppingListItems,
  list: 'shopping-list',
  taxonomy: 'L1',
});
